var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-newsletter"},[_c('div',{staticClass:"header-newsletter--title"},[_vm._v("Norite gauti naujienlaiškius tik apie Jus dominančias temas?")])])
}]

export { render, staticRenderFns }